import * as yup from "yup";

export const addPropertyStep1Schema = yup.object().shape({
  firstCheckbox: yup.bool().oneOf([true], "Confirm this field").required(),
  secondCheckbox: yup.bool().oneOf([true], "Confirm this field").required(),
});
